import StartSection from './startSection';

export default StartSection;
